import { FiAlertCircle } from "react-icons/fi";
import EmailInformation from "./EmailInformation";
import { RiArrowRightSLine } from "react-icons/ri";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import { Collapse } from "antd";
import Language from "./Language";
import BulkSms from "./BulkSms";
import BulkMail from "./BulkMail";
import { IoMailUnreadOutline } from "react-icons/io5";
import { FaLanguage, FaMailBulk } from "react-icons/fa";
import { MdOutlineSms } from "react-icons/md";
import { PiCalculatorFill, PiNotificationBold } from "react-icons/pi";
import AboutUs from "./AboutUs";
import ReferEarn from "./ReferEarn";
import { act, useState, useEffect } from "react";
import { useLocation } from "react-router";
import BulkMobileNotification from "./BulkMobileNotification";
import AppVersionInfo from "./AppVersionInfo";
import { RiMobileDownloadFill } from "react-icons/ri";
const Index = ({active,setActive}) => {

  // const [active, setActive] = useState("0");

  // const handleCollapseChange = (key) => {
  //   if (active !== key) {
  //     setActive(key);
  //   }
  // };
  // console.log(active, 'active_KEY');
  // const [active, setActive] = useState("");

  const handleCollapseChange = (key) => {
    setActive((prev) => (prev === key ? "" : key));
  };

  console.log(active, 'active_KEY');

  return (
    <div className="pr-[0.3vw] pb-[0.5vw]">
      <Collapse
        activeKey={active}
        onChange={() => handleCollapseChange("6")}
        className="bg-[#1F487C] rounded-2xl border border-[#1F487C] shadow-[0_9px_9px_rgba(0,0,0,0.45)] "
        size="large"
        expandIcon={({ isActive }) =>
          isActive ? (
            <IoIosArrowUp
              className="mt-[0.5vw]"
              style={{ color: "#FFFFFF", height: "2vw", width: "1.8vw" }}
            />
          ) : (
            <IoIosArrowDown
              className="mt-[1.5vw]"
              style={{ color: "#FFFFFF", height: "2vw", width: "1.8vw" }}
            />
          )
        }
        expandIconPosition="right"
        items={[
          {
            key: "6",
            label: (
              <div className="flex items-center h-[5vh]">
                <div className="col-span-2 pt-[0.3vw]">
                  <span className="">
                    <IoMailUnreadOutline
                      style={{
                        color: "#FFFFFF",
                        height: "2.3vw",
                        width: "2.3vw",
                      }}
                    />
                  </span>
                </div>
                <div className="col-span-2 pl-[1vw]">
                  <span className="text-[#FFFFFF] font-medium text-[1.1vw]">
                    Email Information
                  </span>
                  <p className="text-[#FFFFFF] text-[0.8vw]">
                    View your system email along with their credentials and descriptions
                  </p>
                </div>
              </div>
            ),
            children: <EmailInformation />,
          },
        ]}
      />
      <Collapse
        className="bg-[#1F487C] rounded-2xl border border-[#1F487C] mt-[1vw] shadow-[0_9px_9px_rgba(0,0,0,0.45)] "
        size="large"
        expandIcon={({ isActive }) =>
          isActive ? (
            <IoIosArrowUp
              className="mt-[0.5vw]"
              style={{ color: "#FFFFFF", height: "2vw", width: "1.8vw" }}
            />
          ) : (
            <IoIosArrowDown
              className="mt-[1.5vw]"
              style={{ color: "#FFFFFF", height: "2vw", width: "1.8vw" }}
            />
          )
        }
        activeKey={active}
        onChange={() => handleCollapseChange("7")}
        expandIconPosition="right"
        items={[
          {
            key: "7",
            label: (
              <div className="flex items-center h-[5vh]">
                <div className="col-span-2 pt-[0.3vw]">
                  <span className="">
                    <FaMailBulk
                      style={{
                        color: "#FFFFFF",
                        height: "2.3vw",
                        width: "2.3vw",
                      }}
                    />
                  </span>
                </div>
                <div className="col-span-2 pl-[1vw]">
                  <span className="text-[#FFFFFF] font-medium text-[1.1vw]">
                    Bulk Mail
                  </span>
                  <p className="text-[#FFFFFF] text-[0.8vw]">
                    Send a single message to multiple recipients with ease using Bulk Mail
                  </p>
                </div>
              </div>
            ),
            children: <BulkMail />,
          },
        ]}
      />
      <Collapse
        className="bg-[#1F487C] rounded-2xl border border-[#1F487C] mt-[1vw] shadow-[0_9px_9px_rgba(0,0,0,0.45)] "
        size="large"
        activeKey={active}
        onChange={() => handleCollapseChange("8")}
        expandIcon={({ isActive }) =>
          isActive ? (
            <IoIosArrowUp
              className="mt-[0.5vw]"
              style={{ color: "#FFFFFF", height: "2vw", width: "1.8vw" }}
            />
          ) : (
            <IoIosArrowDown
              className="mt-[1.5vw]"
              style={{ color: "#FFFFFF", height: "2vw", width: "1.8vw" }}
            />
          )
        }
        expandIconPosition="right"
        items={[
          {
            key: "8",
            label: (
              <div className="flex items-center h-[5vh]">
                <div className="col-span-2 pt-[0.3vw]">
                  <span className="">
                    <MdOutlineSms
                      style={{
                        color: "#FFFFFF",
                        height: "2.3vw",
                        width: "2.3vw",
                      }}
                    />
                  </span>
                </div>
                <div className="col-span-2 pl-[1vw]">
                  <span className="text-[#FFFFFF] font-medium text-[1.1vw]">
                    Bulk Sms
                  </span>
                  <p className="text-[#FFFFFF] text-[0.8vw]">
                   Deliver updates to many recipients at once with Bulk SMS
                  </p>
                </div>
              </div>
            ),
            children: <BulkSms />,
          },
        ]}
      />
      <Collapse
        className="bg-[#1F487C] rounded-2xl border border-[#1F487C] mt-[1vw] shadow-[0_9px_9px_rgba(0,0,0,0.45)] "
        size="large"
        activeKey={active}
        onChange={() => handleCollapseChange("9")}
        expandIcon={({ isActive }) =>
          isActive ? (
            <IoIosArrowUp
              className="mt-[0.5vw]"
              style={{ color: "#FFFFFF", height: "2vw", width: "1.8vw" }}
            />
          ) : (
            <IoIosArrowDown
              className="mt-[1.5vw]"
              style={{ color: "#FFFFFF", height: "2vw", width: "1.8vw" }}
            />
          )
        }
        expandIconPosition="right"
        items={[
          {
            key: "9",
            label: (
              <div className="flex items-center h-[5vh]">
                <div className="col-span-2 pt-[0.3vw]">
                  <span className="">
                    <FaLanguage
                      style={{
                        color: "#FFFFFF",
                        height: "2.3vw",
                        width: "2.3vw",
                      }}
                    />
                  </span>
                </div>
                <div className="col-span-2 pl-[1vw]">
                  <span className="text-[#FFFFFF] font-medium text-[1.1vw]">
                    Language
                  </span>
                  <p className="text-[#FFFFFF] text-[0.8vw]">
                    Select your language to tailor the system to your preference
                  </p>
                </div>
              </div>
            ),
            children: <Language />,
          },
        ]}
      />
          <Collapse
        className="bg-[#1F487C] rounded-2xl border border-[#1F487C] mt-[1vw] shadow-[0_9px_9px_rgba(0,0,0,0.45)] "
        size="large"
        activeKey={active}
        onChange={() => handleCollapseChange("10")}
        expandIcon={({ isActive }) =>
          isActive ? (
            <IoIosArrowUp
              className="mt-[0.5vw]"
              style={{ color: "#FFFFFF", height: "2vw", width: "1.8vw" }}
            />
          ) : (
            <IoIosArrowDown
              className="mt-[1.5vw]"
              style={{ color: "#FFFFFF", height: "2vw", width: "1.8vw" }}
            />
          )
        }
        expandIconPosition="right"
        items={[
          {
            key: "10",
            label: (
              <div className="flex items-center h-[5vh]">
                <div className="col-span-2 pt-[0.3vw]">
                  <span className="">
                      <PiNotificationBold
                        style={{
                        color: "#FFFFFF",
                        height: "2.8vw",
                        width: "2.3vw",}} 
                    />
                  </span>
                </div>
                <div className="col-span-2 pl-[1vw]">
                  <span className="text-[#FFFFFF] font-medium text-[1.1vw]">
                    Bulk Mobile Notification
                  </span>
                  <p className="text-[#FFFFFF] text-[0.8vw]">
                    Notify all app users in a tap — create and send mobile alerts effortlessly
                  </p>
                </div>
              </div>
            ),
            children: <BulkMobileNotification/>,
          },
        ]}
      />
      <Collapse
        className="bg-[#1F487C] rounded-2xl border border-[#1F487C] mt-[1vw] shadow-[0_9px_9px_rgba(0,0,0,0.45)] "
        size="large"
        activeKey={active}
        onChange={() => handleCollapseChange("11")}
        expandIcon={({ isActive }) =>
          isActive ? (
            <IoIosArrowUp
              className="mt-[0.5vw]"
              style={{ color: "#FFFFFF", height: "2vw", width: "1.8vw" }}
            />
          ) : (
            <IoIosArrowDown
              className="mt-[1.5vw]"
              style={{ color: "#FFFFFF", height: "2vw", width: "1.8vw" }}
            />
          )
        }
        expandIconPosition="right"
        items={[
          {
            key: "11",
            label: (
              <div className="flex items-center h-[5vh]">
                <div className="col-span-2 pt-[0.3vw]">
                  <span className="">
                       <RiMobileDownloadFill
                        style={{
                        color: "#FFFFFF",
                        height: "2.8vw",
                        width: "2.3vw",}} 
                    /> 
                  </span>
                </div>
                <div className="col-span-2 pl-[1vw]">
                  <span className="text-[#FFFFFF] font-medium text-[1.1vw]">
                    App Version Info
                  </span>
                  <p className="text-[#FFFFFF] text-[0.8vw]">
                   App Version: Current vs Latest — Stay updated on Android & iOS
                  </p>
                </div>
              </div>
            ),
            children: <AppVersionInfo/>,
          },
        ]}
      />
      {/* <Collapse
        className="bg-[#1F487C] rounded-2xl border border-[#1F487C] mt-[1vw] shadow-[0_9px_9px_rgba(0,0,0,0.45)] shadow-xl"
        size="large"
        activeKey={active}
        onChange={() => handleCollapseChange("5")}
        expandIcon={({ isActive }) =>
          isActive ? (
            <IoIosArrowUp
              className="mt-[0.5vw]"
              style={{ color: "#FFFFFF", height: "2vw", width: "1.8vw" }}
            />
          ) : (
            <RiArrowRightSLine
              className="mt-[1.5vw]"
              style={{ color: "#FFFFFF", height: "2vw", width: "1.8vw" }}
            />
          )
        }
        expandIconPosition="right"
        items={[
          {
            key: "5",
            label: (
              <div className="flex items-center h-[5vh]">
                <div className="col-span-2 pt-[0.3vw]">
                  <span className="">
                    <PiCalculatorFill
                      style={{
                        color: "#FFFFFF",
                        height: "2.3vw",
                        width: "2.3vw",
                      }}
                    />
                  </span>
                </div>
                <div className="col-span-2 pl-[1vw]">
                  <span className="text-[#FFFFFF] font-medium text-[1.1vw]">
                    Legal Documents
                  </span>
                  <p className="text-[#FFFFFF] text-[0.8vw]">
                    Manage your about us, Privacy Policy, Terms & Condition,
                    User Agreement
                  </p>
                </div>
              </div>
            ),
            children: <AboutUs />,
          },
        ]}
      /> */}
      {/* <Collapse
        className="bg-[#1F487C] rounded-2xl border border-[#1F487C] mt-[1vw] shadow-[0_9px_9px_rgba(0,0,0,0.45)] shadow-xl"
        size="large"
        activeKey={active}
        onChange={() => handleCollapseChange("6")}
        expandIcon={({ isActive }) =>
          isActive ? (
            <IoIosArrowUp
              className="mt-[0.5vw]"
              style={{ color: "#FFFFFF", height: "2vw", width: "1.8vw" }}
            />
          ) : (
            <RiArrowRightSLine
              className="mt-[1.5vw]"
              style={{ color: "#FFFFFF", height: "2vw", width: "1.8vw" }}
            />
          )
        }
        expandIconPosition="right"
        items={[
          {
            key: "6",
            label: (
              <div className="flex items-center h-[5vh]">
                <div className="col-span-2 pt-[0.3vw]">
                  <span className="">
                    <PiCalculatorFill
                      style={{
                        color: "#FFFFFF",
                        height: "2.3vw",
                        width: "2.3vw",
                      }}
                    />
                  </span>
                </div>
                <div className="col-span-2 pl-[1vw]">
                  <span className="text-[#FFFFFF] font-medium text-[1.1vw]">
                    Refer and Earn
                  </span>
                </div>
              </div>
            ),
            children: <ReferEarn />,
            // children: <AboutUs />,
          },
        ]}
      /> */}
    </div>
  );
};

export default Index;
